// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line[data-v-2a9e85fc] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.line p[data-v-2a9e85fc] {\n    width: 150px;\n    font-size: 15px;\n}\n.line span[data-v-2a9e85fc] {\n    font-size: 15px;\n    color: #000;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
